import type { UserPersona } from '@/Network/Types/Responses/AuthResponses'
import PATHS from '@/router/paths'

export type PostLoginTarget =
  | { kind: 'navigate'; path: string; fetchPermissions: boolean }
  | { kind: 'blocked'; message: string }

export const AFFILIATE_PORTAL_UNAVAILABLE_MESSAGE =
  'O Portal do Afiliado ainda não está disponível. Fale com a equipe Minha Escala.'

/** Para onde o login leva cada persona (spec §4.5). Sem persona = gestão (backend antigo). */
export function resolvePostLoginTarget(
  persona: UserPersona | undefined,
  affiliateEnabled: boolean
): PostLoginTarget {
  if (persona === 'ANTECIPE_AFFILIATE') {
    return affiliateEnabled
      ? { kind: 'navigate', path: PATHS.AFFILIATE_OVERVIEW, fetchPermissions: false }
      : { kind: 'blocked', message: AFFILIATE_PORTAL_UNAVAILABLE_MESSAGE }
  }
  return { kind: 'navigate', path: PATHS.DASHBOARD, fetchPermissions: true }
}
